import React from 'react';
import { Modal, Button } from 'antd';
import './ConfirmationModel.css';

const ConfirmationModal = ({ visible, onConfirm, onCancel, message, deletetext , }) => {
  return (
    <Modal
      open={visible}
      onCancel={onCancel}
      footer={null}
      centered
      title="Confirmation"
      width={300}
    >
      <h3 style={{ textAlign: 'center' }} >{message || 'Are you sure you want to proceed?'}</h3>
      <div className="confirmation-modal-footer">

        <Button onClick={onCancel} type="primary" className="yes-button"   style={{ marginRight: '8px' }}>
          Cancel
        </Button>
        <Button  className="no-button" onClick={onConfirm}>
          {deletetext ? deletetext : 'Delete'}

        </Button>
      </div>
    </Modal>
  );
};

export default ConfirmationModal;
